import { render, staticRenderFns } from "./vc-dialog.vue?vue&type=template&id=5723108e&scoped=true&"
import script from "./vc-dialog.vue?vue&type=script&lang=js&"
export * from "./vc-dialog.vue?vue&type=script&lang=js&"
import style0 from "./vc-dialog.vue?vue&type=style&index=0&id=5723108e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723108e",
  null
  
)

export default component.exports